import React from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import Instancenav from './../common/instancenav/instancenavigation';
import HeaderBottom from './../common/headerBottom/headerBottom';
import HeaderTop from './../common/headerTop/headerTop';
import LeftNav from './../common/leftnav/leftnav';
import Summary from './summary/summary';
import Networking from './networking/networking';
import Backup from './backup/backup';
import Snapshot from './snapshots/snapshots';
import Resize from './resize/resize';
import Rebuild from './rebuild/rebuild';
import Activity from './activities/activity';
import Setting from './settings/setting';
import $ from 'jquery';
import CommonMessage from './../common/commonMessage';
import Rescue from './rescue';
import { ServerService } from './../../services/server.service';
import Volumes from './volumes';
import ImageService from '../../services/image.service';
import NotificationSlider from '../common/topRightHeader/notificationSlider';
import BmrSlider from '../common/topRightHeader/bmrSlider';
import InstanceBilling from './instancebilling/instancebillling';

class Server extends React.Component {
    constructor(props) {
        super(props);
        let server = {};
        if(sessionStorage.server) {
            server = JSON.parse(sessionStorage.server);
        }
        if(server === undefined) {
            return;
        }
        this.state = {
            Isactive: false,
            IsnotificationActive: false,
            username: "",
            id: server.id,
            computeRegionUrl: server.computeRegionUrl,
            imageRegionUrl: server.imageRegionUrl,
            message: '',
            msgType: '',
            isAction: false,
            instance: server.instance,
            regionName: server.regionName,
            isTaskStateNull: true,
            instImage: '',
            isSnapshotProgress: false
        };
        this.showUserAccount = this.showUserAccount.bind(this);
        this.showNotification = this.showNotification.bind(this);
        //this.loadcss();
        this.rescueRef = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if(this.props.location !== prevProps.location) {
            //this.setState({navParam: this.props.match.params.sub});
        }
    }

    componentDidMount() {
        if(this.state.id === undefined) {
            this.props.history.push('/index');
            return;
        } else {
            this.setImageDetails();
            this.doInstTaskStateCheck();
            //this.setState({ id: this.state.id});            
        }
        window.scrollTo(0, 0);
    }

    setImageDetails() {
        ImageService.getImageById(this.state.imageRegionUrl, this.state.instance.image.id).then(resp => {

            if(resp && resp.name) {
                this.setState({ instImage: resp, imageAndFlavor: this.getFlavoranImageDetails(this.state.instance.flavor.id, resp.name) });
            } else {
                this.setState({ imageAndFlavor: this.getFlavoranImageDetails(this.state.instance.flavor.id, '') });
            }

        });
    }

    loadcss() {
        $('<link rel="stylesheet" href="https://www.idrivecompute.com/webapp/css/circle-progress.css" />').appendTo('head');
    }

    showUserAccount() {
        if(this.state.IsnotificationActive) {
            this.setState({
                IsnotificationActive: !this.state.IsnotificationActive
            });
        }
        this.setState({
            Isactive: !this.state.Isactive
        });
    }
    showNotification() {
        if(this.state.Isactive) {
            this.setState({
                Isactive: !this.state.Isactive
            });
        }
        this.setState({
            IsnotificationActive: !this.state.IsnotificationActive
        });
    }

    doRescueStatusCheck(status) {
        this.setState({ isAction: true });
        let intervalId = sessionStorage.serverIntervalId = setInterval(() => {
            ServerService.getServerDetailsById(this.state.computeRegionUrl, this.state.instance.id).then(resp => {
                if(resp && resp.id === this.state.id && resp.status !== status) {
                    clearInterval(intervalId);
                    this.rescueRef.current.updateUnrescueAction();
                    let server = JSON.parse(sessionStorage.server);
                    server.instance = resp;
                    server.instance.region = this.state.instance.region;
                    this.setState({ instance: server.instance });
                    sessionStorage.server = JSON.stringify(server);
                    this.setState({ isAction: false });
                }

            });
        }, 10000);
    }

    doInstTaskStateCheck() {
        ServerService.getServerDetailsById(this.state.computeRegionUrl, this.state.instance.id).then(resp => {
            // console.log("check");
            if(resp && resp.id === this.state.id) {
                if(resp.taskState === null) {
                    clearTimeout(sessionStorage.taskTimeoutId);
                    this.setState({ isTaskStateNull: true, isSnapshotProgress: false });
                    //console.log("check1");
                } else {
                    // console.log("check2");

                    sessionStorage.taskTimeoutId = setTimeout(() => {
                        this.doInstTaskStateCheck();
                    }, 1000);
                    this.setState({ isTaskStateNull: false, isSnapshotProgress: true });
                }

            } else {
                this.setState({ isTaskStateNull: true });
            }
        });
    }

    disableBttn() {
        this.setState({ isTaskStateNull: false });
    }

    updateSettings(instanceData) {
        instanceData.region = this.state.instance.region;
        this.setState({ instance: instanceData });
    }
    componentWillUnmount() {
        clearInterval(sessionStorage.instanceListInterval);
        clearTimeout(sessionStorage.taskTimeoutId);
    }
    getFlavoranImageDetails(flavorId, instImageName) {
        try {
            let flavorList = JSON.parse(localStorage.getItem('flavorList'));
            let BmList = JSON.parse(localStorage.getItem('BMflavors'));
            if(flavorList !== null && flavorList !== undefined) {
                let flavorObj = undefined;
                try {
                    flavorObj = flavorList.find(item => item.flavour_id === flavorId);
                }
                catch(err) {
                    return '';
                }

                if(flavorObj === undefined) {
                    return '';
                }
                let nameArr = flavorObj.name.split(' ');
                let type = 'Shared CPU';
                let processorType = 'vCPU, ';
                if(nameArr[0].includes('DCPU')) {
                    type = 'Dedicated CPU';
                    processorType = 'CPU, ';
                }
                let details = nameArr[1].toString().split('/');
                let ram = details[0];
                let processor = flavorObj.vcpus;
                let storage = details[2];
                let imageName = instImageName && instImageName !== '' ? instImageName + ', ' : '';
                if(nameArr[0].includes('BM')) {

                    type = 'Bare Metal';

                    let bmObj = undefined;
                    try {
                        bmObj = BmList.find(item => item.id === flavorId);
                    }

                    catch(err) {
                        return '';
                    }

                    if(bmObj === undefined) {
                        return '';
                    }
                    processor = bmObj.processor + ", ";
                    processorType = bmObj.cpus + ', ';
                    ram = bmObj.ram;
                    storage = bmObj.storage;

                }

                return imageName + type + ', ' + processor + processorType + ram + ' RAM, ' + storage + ' NVMe storage';
            }
        } catch(e) {
            console.log(e);
            return '';
        }

        return '';
    }

    render() {
        if(this.state.id === undefined) {
            return null;
        }

        return (
            <div className="instance_settings_ui settingModule_wrapper">
                <div data-gr-c-s-loaded="true">
                    <main>
                        <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                            <div className="loader_icon"></div>
                        </div>

                        <LeftNav isActive={ 'instances' }></LeftNav>
                        <div className="main_container">
                            <header className="header_wrap">
                                <HeaderTop />
                                <NotificationSlider />
                                <HeaderBottom computeRegionUrl={ this.state.computeRegionUrl } bgShadowHandler={ (isAction) => this.setState({ isAction: isAction }) }
                                    msgHandler={ (msg, mesgType) => this.setState({ message: msg, msgType: mesgType }) } history={ this.props.history } isAction={ this.state.isAction }
                                    imageAndFlavor={ this.state.imageAndFlavor } instImage={ this.state.instImage } instance={ this.state.instance } isTaskStateNull={ this.state.isTaskStateNull } isSnapshotProgress={ this.state.isSnapshotProgress } />
                            </header>
                            <section className="main_section">
                                <div className={ this.state.instance.status.toLowerCase() === 'error' ? "main_body_container toggle_menu" : "main_body_container" }>
                                    <Instancenav isTaskStateNull={ this.state.isTaskStateNull } instance={ this.state.instance } />
                                    <Switch>
                                        <Route path="/server/summary" >
                                            <Summary instanceId={ this.state.id } imageRegionUrl={ this.state.imageRegionUrl } computeRegionUrl={ this.state.computeRegionUrl }
                                                bgShadowHandler={ (isAction) => this.setState({ isAction: isAction }) } instance={ this.state.instance }
                                                msgHandler={ (msg, mesgType) => this.setState({ message: msg, msgType: mesgType }) } />
                                        </Route>
                                        <Route path="/server/networking" >
                                            <Networking instanceId={ this.state.id } imageRegionUrl={ this.state.imageRegionUrl } computeRegionUrl={ this.state.computeRegionUrl }
                                                bgShadowHandler={ (isAction) => this.setState({ isAction: isAction }) } isTaskStateNull={ this.state.isTaskStateNull }
                                                msgHandler={ (msg, mesgType) => this.setState({ message: msg, msgType: mesgType }) } instImage={ this.state.instImage }
                                                instance={ this.state.instance } history={ this.props.history } i18n={ this.props.i18n } />
                                        </Route>
                                        <Route path="/server/backups" >
                                            <Backup instanceId={ this.state.id } imageRegionUrl={ this.state.imageRegionUrl } computeRegionUrl={ this.state.computeRegionUrl }
                                                bgShadowHandler={ (isAction) => this.setState({ isAction: isAction }) } instance={ this.state.instance }
                                                msgHandler={ (msg, mesgType) => this.setState({ message: msg, msgType: mesgType }) } i18n={ this.props.i18n } />
                                        </Route>
                                        <Route path="/server/snapshots" >
                                            <Snapshot instanceId={ this.state.id } imageRegionUrl={ this.state.imageRegionUrl } computeRegionUrl={ this.state.computeRegionUrl }
                                                bgShadowHandler={ (isAction) => this.setState({ isAction: isAction }) } i18n={ this.props.i18n }
                                                msgHandler={ (msg, mesgType) => this.setState({ message: msg, msgType: mesgType }) } doInstTaskStateCheck={ () => this.doInstTaskStateCheck() }
                                                history={ this.props.history } instance={ this.state.instance } regionName={ this.state.regionName }
                                                disableBttn={ () => this.disableBttn() } />
                                        </Route>
                                        <Route path="/server/voume-instance" >
                                            <Volumes instanceId={ this.state.id } imageRegionUrl={ this.state.imageRegionUrl } computeRegionUrl={ this.state.computeRegionUrl }
                                                bgShadowHandler={ (isAction) => this.setState({ isAction: isAction }) } i18n={ this.props.i18n }
                                                msgHandler={ (msg, mesgType) => this.setState({ message: msg, msgType: mesgType }) }
                                                instance={ this.state.instance } history={ this.props.history } isTaskStateNull={ this.state.isTaskStateNull }
                                            />
                                        </Route>
                                        <Route path="/server/resize" >
                                            <Resize instanceId={ this.state.id } imageRegionUrl={ this.state.imageRegionUrl } computeRegionUrl={ this.state.computeRegionUrl }
                                                bgShadowHandler={ (isAction) => this.setState({ isAction: isAction }) } i18n={ this.props.i18n }
                                                msgHandler={ (msg, mesgType) => this.setState({ message: msg, msgType: mesgType }) }
                                                instance={ this.state.instance } history={ this.props.history } isTaskStateNull={ this.state.isTaskStateNull }
                                            />
                                        </Route>
                                        <Route path="/server/rescue" >
                                            <Rescue instanceId={ this.state.id } imageRegionUrl={ this.state.imageRegionUrl } computeRegionUrl={ this.state.computeRegionUrl }
                                                bgShadowHandler={ (isAction) => this.setState({ isAction: isAction }) } i18n={ this.props.i18n }
                                                msgHandler={ (msg, mesgType) => this.setState({ message: msg, msgType: mesgType }) }
                                                instance={ this.state.instance } history={ this.props.history } updateInstStatus={ (status) => this.doRescueStatusCheck(status) } ref={ this.rescueRef } isTaskStateNull={ this.state.isTaskStateNull }
                                            />
                                        </Route>
                                        <Route path="/server/rebuild" >
                                            <Rebuild instanceId={ this.state.id } imageRegionUrl={ this.state.imageRegionUrl } computeRegionUrl={ this.state.computeRegionUrl }
                                                bgShadowHandler={ (isAction) => this.setState({ isAction: isAction }) } i18n={ this.props.i18n }
                                                msgHandler={ (msg, mesgType) => this.setState({ message: msg, msgType: mesgType }) }
                                                instance={ this.state.instance } history={ this.props.history } isTaskStateNull={ this.state.isTaskStateNull }
                                            />
                                        </Route>
                                        <Route path="/server/instancebilling" >
                                            <InstanceBilling instanceId={ this.state.id } imageRegionUrl={ this.state.imageRegionUrl } computeRegionUrl={ this.state.computeRegionUrl }
                                                bgShadowHandler={ (isAction) => this.setState({ isAction: isAction }) } i18n={ this.props.i18n }
                                                msgHandler={ (msg, mesgType) => this.setState({ message: msg, msgType: mesgType }) }
                                                instance={ this.state.instance } history={ this.props.history } isTaskStateNull={ this.state.isTaskStateNull }
                                            />
                                        </Route>
                                        <Route path="/server/activities" >
                                            <Activity instanceId={ this.state.id } imageRegionUrl={ this.state.imageRegionUrl } computeRegionUrl={ this.state.computeRegionUrl }
                                                bgShadowHandler={ (isAction) => this.setState({ isAction: isAction }) } i18n={ this.props.i18n }
                                                msgHandler={ (msg, mesgType) => this.setState({ message: msg, msgType: mesgType }) } />
                                        </Route>
                                        <Route path="/server/settings" >
                                            <Setting instanceId={ this.state.id } instance={ this.state.instance } imageRegionUrl={ this.state.imageRegionUrl } computeRegionUrl={ this.state.computeRegionUrl }
                                                bgShadowHandler={ (isAction) => this.setState({ isAction: isAction }) } i18n={ this.props.i18n }
                                                msgHandler={ (msg, mesgType) => this.setState({ message: msg, msgType: mesgType }) } isTaskStateNull={ this.state.isTaskStateNull }
                                                history={ this.props.history } updateInstData={ (instanceData) => this.updateSettings(instanceData) } />
                                        </Route>
                                    </Switch>
                                </div>
                            </section>
                        </div>
                    </main>

                </div>
                <CommonMessage message={ this.state.message } handler={ () => this.setState({ message: '' }) }
                    msgType={ this.state.msgType } />
            </div>
        );
    }
}

export default Server;
